<template>
  <div>
    <div class="userPage">
    <div class="userTop">
      <h2></h2>
    </div>
    <div class="card">
      <div class="cardT1">
        <div>
          <img :src="user.img?user.img:'https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/avatars.png'" alt="" />
        </div>
        <div>
          <h3>{{user.name?user.name:user.nickname}}</h3>
          <p>{{user.duties?user.duties:""}}</p>
        </div>
      </div>
      <p><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/youxiang.png" alt="" />{{user.email?user.email:"暂无"}}</p>
      <p><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/dianhua.png" alt="" />{{user.mobile?user.mobile:user.phone}}</p>
      <p><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/dizhi.png" alt="" />{{user.corpname}}</p>
      <img @click="()=>$router.push('/userapp/modified/1')" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/bianji.png" alt="" />
    </div>
    <!-- 我的收藏 -->
    <div class="userList collection">
      <h4><span></span>User Center</h4>
      <ul>
        <li v-for="(item,index) in collect" :key="'sc'+index" @click="()=>$router.push(item.url)">
          <img :src="item.img_url" alt="" />
          {{item.title_en}}
        </li>
      </ul>
    </div>
    <!-- 展会相关 -->
    <div class="userList related">
      <h4><span></span> Exhibition Related</h4>
      <ul>
        <li @click="appHerf('https://en.cippe.com.cn/about-introduction')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/zhanhuigaikuang.png" alt="" />
          General Introduction
        </li>
        <li @click="appHerf('http://e.cippe.com.cn/OfflineExDB/BJ2021/en-exlist.html')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/zhanqianyulan.png" alt="" />
          Exhibition Preview
        </li>
        <li @click="appHerf('https://en.cippe.com.cn/visitor-guide')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/canguanzhinan.png" alt="" />
          Visitor Guide
        </li>
        <li @click="appHerf('https://en.cippe.com.cn/accommodation')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/jiudianyuding.png" alt="" />
          Hotel Booking
        </li>
        <li @click="appHerf('https://en.cippe.com.cn/trafficmap/')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/jiaotongditu.png" alt="" />
          Traffic Map
        </li>
        <li @click="appHerf('https://en.cippe.com.cn/exhibition-stand-contractor/')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/dajian.png" alt="" />
          Official Contractors
        </li>
        <li @click="appHerf('https://en.cippe.com.cn/freight-forwarder')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/yunshu.png" alt="" />
          Transportation Services
        </li>
      </ul>
    </div>
    <!-- 联系热线 -->
    <ul class="hotline">
      <a href="tel:010-56176968">
        <li>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/canzhan.png" alt="" />
          <p>
            <span>Exhibitor Hotline:</span><span class="colorPhone">010-56176968</span>
          </p>
        </li>
      </a>
      <a href="tel:010-56176941">
        <li>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/cangaun.png" alt="" />
          <p>
            <span>Visitor Hotline:</span><span class="colorPhone">010-56176941</span>
          </p>
        </li>
      </a>
      <a href="tel:010-50917095">
        <li>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/rexian.png" alt="" />
          <p>
            <span>Technique Hotline:</span><span class="colorPhone">010-50917095</span>
          </p>
        </li>
      </a>
      <a href="tel:010-50917091">
        <li>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/rexian.png" alt="" />
          <p>
            <span>Media Hotline:</span><span class="colorPhone">010-50917091</span>
          </p>
        </li>
      </a>
    </ul>
    <div class="btn">
      <button @click="outLogin">Log Out</button>
    </div>
  </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components:{

  },
  data () {
    return {
      selected:"1",
      collect:[
         {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/yixiangdingdan.png",
          url:"/userapp/intentionOrder",
          title_cn:"意向订单",
          title_en:"My orders",
          title:"意向订单",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/zhanshangshoucang.png",
          url:"/userapp/merchantsCollection",
          title:"展商收藏",
          title_en:"Exhibitor Favorites",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/zhanpinshoucang.png",
          url:"/userapp/goodsCollection",
          title:"展品收藏",
          title_en:"My Favorite Products",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/yiyuezhanshang.png",
          url:"/userapp/aboutGoods",
          title:"已约展商",
          title_en:"My Appointments",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/xunpan.png",
          url:"/userapp/consulting",
          title:"询盘咨询",
          title_en:"Enquiry",
        }
      ],
      
    }
  },
  mounted () {
    sessionStorage.setItem('selected','/user')
  },
  methods:{
    loadMore(){
    },
    outLogin(){//退出登录
      this.$store.dispatch("outLogin")
      this.$router.push("/home")
    },
  },
  computed:{
    ...mapState({
      user:state=>state.user.user,
      isLogin:state=>state.user.isLogin,
    })
  },
}
</script>

<style scoped>
  .userTop{
    margin-left: -10px;
    margin-right: -10px;
    height: 200px;
    background-color: #008baf;
    color: white;
    padding: 15px 10px;
    box-sizing: border-box;
  }
  .userTop h2{
    font-size: 13px;
  }
  .card{
    position: relative;
    margin-top: -150px;
    width: 100%;
    /* height: 500px; */
    padding: 15px 25px;
    border-radius: 10px;
    background-color: white;
    overflow: hidden;
    box-shadow: 2px 2px 10px #cecece;
    margin-bottom: 40px;
  }
  .cardT1{
    /* height: 200px; */
    display: flex;
    padding-bottom:15px ;
    border-bottom: 1px solid #e5e5e5;
  }
  .cardT1 div:first-child{
    width: 70px;
    height: 70px;
    border-radius: 50%;
    overflow: hidden;
    vertical-align: middle;
  }
  .cardT1 div:nth-child(2){
    margin-left: 15PX;
    margin-top: 10px;
  }
  .cardT1 h3{
    font-size: 18px;
    font-weight: 600;
    /* margin-bottom: 10px; */
  }
  .card p{
    margin-top: 10px;
  }
  .card p img{
    margin-right: 8px;
    color: #808080;
    width: 20px;
    height: 20px;
    vertical-align: middle;
  }
  .card > img{
    position: absolute;
    right: 10px;
    top: 10px;
    /* color: #808080; */
    width: 40px;
    height: 40px;
  }

  .userList{
    margin-left: -10px;
    margin-right: -10px;
    margin-bottom: 30px;
    background-color: white;
    padding: 10px;

  }
  .userList h4{
    font-size: 16px;
    color: #008baf;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .userList span{
    display:inline-block;
    height:16px;
    width: 4px;
    background-color: #008baf;
    margin-right: 5px;
    vertical-align: middle;
  }
  .userList ul{
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    /* justify-content: space-around; */
    text-align: center;
  }
  .userList li{
    width: 23%;
    margin-left: 1.6%;
    margin-bottom: 15px;
    text-align: center;
  }
  .userList li img{
    display: block;
    font-size: 30px;
    /* margin-bottom: 5px; */
    /* width: 40px; */
    height: 40px;
  }
  .hotline{
    background-color: white;
    margin-left: -10px;
    margin-right: -10px;
    padding: 10px 0 10px 10px;
  }
  .hotline li{
    display: flex;
    align-items: center;
  }
  .hotline li img{
    font-size: 18px;
    width: 30px;
  }
  .hotline li p{
    border-bottom: 1px solid #eee;
    padding: 10px 0;
    width: calc(100vw - 40px);
  }
  .btn{
    padding: 20px;
  }
  .btn button{
    border: none;
    border-radius: 5px;
    color: white;
    background-color: #f56c6c;
    width: 100%;
    padding: 12px 0;
  }
</style>